import React, { useEffect, useRef, useState } from "react";
import { Modal } from "reactstrap";
import { useHistory } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import API from "api.js";
import PhoneInputField from "./PhoneInputField";

/**
 * Shared "Book a free trial / visit" popup.
 * This is the same announcement popup used on the Home page, extracted into a
 * reusable component so Home.jsx and Branches.jsx share a single source of truth.
 *
 * Props:
 *  - isOpen        : boolean, controls modal visibility
 *  - onClose       : () => void, called when the modal should close
 *  - branches      : array of branch objects (each with branch_detail.title)
 *  - defaultCenter : string, pre-selected center value
 */
const BookVisitPopup = ({ isOpen, onClose, branches = [], defaultCenter = "" }) => {
  const history = useHistory();
  const validator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [center, setCenter] = useState(defaultCenter);
  const [process, setProcess] = useState(false);

  // Keep the selected center in sync with the branch the user clicked.
  useEffect(() => {
    if (isOpen) {
      setCenter(defaultCenter || "");
    }
  }, [isOpen, defaultCenter]);

  const closeIndexModal = (e) => {
    if (e) e.preventDefault();
    if (onClose) onClose();
  };

  const postSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!validator.current.allValid()) {
      validator.current.showMessages();
      forceUpdate((v) => v + 1);
      return false;
    }

    setProcess(true);
    const bodyFormData = new FormData();
    bodyFormData.append("phone", phone);
    bodyFormData.append("name", name);
    bodyFormData.append("email", email);
    bodyFormData.append("center", center);

    let res = null;
    try {
      res = await API({
        method: "POST",
        url: "/submit-query",
        data: bodyFormData,
      });
    } catch (error) {
      setProcess(false);
      return;
    }

    if (res && res.status === 200) {
      setProcess(false);
      if (onClose) onClose();
      history.push({ pathname: "/trial-class-thankyou", state: { flag: true } });
    } else {
      setProcess(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => closeIndexModal()}
      size="lg"
      id="anouncementPopup"
      centered
      zIndex={20000}
      backdrop
    >
      <div className="modal-content" style={{ position: "relative" }}>
        <button
          type="button"
          onClick={(e) => closeIndexModal(e)}
          aria-label="Close"
          style={{
            position: "absolute",
            top: "10px",
            right: "12px",
            zIndex: 5,
            width: "34px",
            height: "34px",
            borderRadius: "50%",
            border: "none",
            background: "#ffffff",
            color: "#93c13e",
            fontSize: "26px",
            lineHeight: "1",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="modal-body pte_popup_modal_body">
          <div className="row">
            <div className="col-md-6 col-sm-6 col-xs-12">
              <img
                className="pte-popup-logo-img"
                style={{ width: "100px" }}
                src="/images/logol.png"
                alt="Language Academy"
              />
              <p className="pte_popup_modal_ptag"></p>
              <div>
                <h2
                  className="pte_popup_modal_h2tag pte_popup_modal_h2tagl1"
                  style={{ textAlign: "center", fontSize: "23px", margin: "30px 0px 0px 0px", padding: "0px", fontWeight: "700" }}
                >
                  Attend a{" "}
                </h2>
                <h2
                  className="pte_popup_modal_h2tag pte_popup_modal_h2tagl2"
                  style={{ fontSize: "27px", fontStyle: "italic", margin: "5px 0px", textAlign: "center" }}
                >
                  <b style={{ color: "#a7ff00" }}>FREE TRIAL CLASS</b>{" "}
                </h2>
                <h2
                  className="pte_popup_modal_h2tag pte_popup_modal_h2tagl3"
                  style={{ textAlign: "center", fontSize: "23px", margin: "0px", padding: "0px", color: "black" }}
                >
                  for PTE, NAATI CCL or IELTS with us.
                </h2>
                <p className="pte_popup_modal_ptag" style={{ color: "red", fontWeight: "700" }} id="timer-id">
                  {" "}
                </p>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12 pte_popup_modal_seccol">
              <div className="pte_popup_modal_sec_inner_col">
                <h4 className="pte_popup_modal_h4tag" style={{ textAlign: "center" }}>
                  Book NOW!
                </h4>
                <p className="pte_popup_modal_ptag" style={{ textAlign: "center" }}>
                  Submit Your Details Below
                </p>
                <p className="pte_popup_modal_ptag" style={{ textAlign: "center" }}>
                  <i className="fas fa-long-arrow-alt-down"></i>
                </p>
                <div className="pte-popup-form-start">
                  <form onSubmit={postSubmit}>
                    <div className="col-md-12">
                      <input
                        className="ptepop_name form-control"
                        onChange={(e) => setName(e.target.value)}
                        value={name}
                        name="name"
                        placeholder="Name*"
                        type="text"
                      />
                      {validator.current.message("name", name, "required")}
                      <span className="err name-error"></span>
                    </div>

                    <div className="col-md-12 mt-2">
                      <PhoneInputField onChange={(val) => setPhone(val)} customClass={""} />
                      {validator.current.message("phone", phone, "required|phone")}
                      <span className="err phone-error"></span>
                    </div>

                    <div className="col-md-12">
                      <div className="pte-modal-inputf-gap" style={{ height: "10px" }}></div>
                      <input
                        className="form-control ptepop_email"
                        name="email"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                        placeholder="Email Address*"
                        type="email"
                      />
                      {validator.current.message("email", email, "required|email")}
                      <span className="err email-error"></span>
                    </div>

                    <div className="col-md-12">
                      <div className="pte-modal-inputf-gap" style={{ height: "10px" }}></div>
                      <select
                        className="form-control ptepop_email"
                        name="center"
                        onChange={(e) => setCenter(e.target.value)}
                        value={center}
                      >
                        <option value="">Select center</option>
                        {branches.map((branch) => (
                          <React.Fragment key={branch.id}>
                            {branch.branch_detail?.title && (
                              <option value={branch.branch_detail.title}>
                                {branch.branch_detail.title}
                              </option>
                            )}
                          </React.Fragment>
                        ))}
                        <option value="Online">Online</option>
                      </select>
                      {validator.current.message("center", center, "required")}
                      <span className="err email-error"></span>
                    </div>

                    <div className="col-md-12 row_before_pte_submit">
                      <div className="pte-modal-inputf-gap" style={{ height: "10px" }}></div>
                      {!process && (
                        <a onClick={postSubmit} className="btn btn-primary pte_popup_modal_submit">
                          Submit
                        </a>
                      )}
                      {process && <a className="btn btn-primary pte_popup_modal_submit">Wait...</a>}
                    </div>
                  </form>
                </div>
                <div className="pte-modal-inputf-gap" style={{ height: "10px" }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BookVisitPopup;
